<template>
  <el-container class="height100">
    <el-container v-show="showmode=='LIST'" class="el-mainContent height100 overflowYHidden"  direction="vertical"  ref="managerMain">
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight"  ref="normalHeight">
        <el-col :span="16" class="normalLineH">{{$t('fieldextend')}}</el-col>
        <el-col :span="8" class="align-right normalLineH">
          <el-button type="primary" @click="onCreateBtnClick" size="small">{{$t('new')}}</el-button>
          <el-button @click="onDeleteBtnClick" size="small" type="danger" plain>{{$t('del')}}</el-button>
        </el-col>
      </el-row>

      <!-- 字段扩展查询 -->
      <el-row  ref="search">
        <el-col :span="16">
          <el-form :inline="true" :model="searchdata" class="form-inline" size="mini" >
            <el-form-item :label="$t('type')">
              <el-select v-model="searchdata.data.type" class="el-select-w">
                <el-option :label="$t('placeholder_select')" value=""></el-option>
                <el-option :label="$t('string')" value="string"></el-option>
                <el-option :label="$t('clob')" value="clob"></el-option>
                <el-option :label="$t('date')" value="date"></el-option>
                <el-option :label="$t('upload')" value="upload"></el-option>
                <el-option :label="$t('radio')" value="radio"></el-option>
                <el-option :label="$t('checkbox')" value="checkbox"></el-option>
                <el-option :label="$t('select')" value="select"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('owned_field')">
              <el-select v-model="searchdata.data.fortable"  class="el-select-w">
                <el-option :label="$t('placeholder_select')" value=""></el-option>
                <el-option :label="$t('tableUser')" value="tableUser"></el-option>
                <el-option :label="$t('tableDept')" value="tableDept"></el-option>
                <el-option :label="$t('tableDomain')" value="tableDomain"></el-option>
              </el-select>  
            </el-form-item>
            <el-form-item>
              <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
              <el-button @click="resetTableData">{{$t('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- 字段扩展列表 -->
      <el-table :data="fieldextends.datas"
        stripe
        @row-click="onRowClick"
        ref="multipleTable"
        :row-key="handleReserve" 
        @selection-change="handleSelectionChange"
        header-cell-class-name="tableHeaderbg"
        class="Trpointer overflowYScroll"
        size="small"
        :height="tableListConHeight">
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="name" :label="$t('owned_field')" ></el-table-column>
        <el-table-column prop="label" :label="$t('show_label')"></el-table-column>
        <el-table-column :label="$t('type')">
          <template slot-scope="scope">
            {{scope.row.type == "string" ? $t('string') : 
            scope.row.type == "date" ? $t('date') : 
            scope.row.type == "radio" ? $t('radio') : 
            scope.row.type == "checkbox" ? $t('checkbox') : 
            scope.row.type == "select" ? $t('select') : 
            scope.row.type == "upload" ? $t('upload') : 
            $t('clob')}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('show_list')">
          <template slot-scope="scope">{{scope.row.enabel? $t('show') : $t('not_show')}}</template>
        </el-table-column>
        <el-table-column  :label="$t('owned_field')">
          <template slot-scope="scope">{{scope.row.forTable == "tableUser"? $t('tableUser') : scope.row.forTable == "tableDept"? $t('tableDept') :  $t('tableDomain')}}</template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="searchTableData"
          :current-page.sync="searchdata.currpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchdata.pagelines"
          :page-count="4"
          layout="prev, pager, next, total, sizes"
          background
          :total="fieldextends.rowCount?fieldextends.rowCount:0"
        ></el-pagination>
    </el-container>
    <el-container v-if="showmode=='DETAIL'" class="el-mainContent">
      <fieldextend_detail :detail="content" :mode="mode" @exit="onExit"/>
    </el-container>
  </el-container>
</template>

<script>
import fieldextend_detail from "@/components/fieldextend_detail.vue";
export default {
  components: { fieldextend_detail },
  data() {
    return {
      fieldextends: [],
      content: {},
      showmode: "LIST", //LIST 或 DETAIL，默认为LIST
      searchdata:{
        currpage:1,
        pagelines:10,
        data:{
          type:"",
          fortable:"",
          domainid: this.$route.query.domainid,
          belong:"All"
        }
      },
      multipleTable:[],
      multipleSelection:[],
      mode:"detail",
      tableListConHeight:null,
    };
  },
  props:["SystemFile"],
  watch:{
    detail(newVal){
      this.detail=newVal;
    }
  },

  created() {
    this.searchTableData();
  },
  mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight= document.documentElement.clientHeight;
  
  },
  methods: {

    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },

    handleSelectionChange(val){
      var arr = [];
       val.forEach((val) => {
        this.fieldextends.datas.forEach((v) => {
          if(val.fid == v.fid){
            let data=val.name+"-"+val.fid+"-"+val.forTable
            arr.push(data);
            
          }
        })
      })   
      this.multipleSelection = arr;
    },
    handleReserve(row){
      return row.fid
    },
    onCreateBtnClick() {
      this.showmode = 'DETAIL';
      this.mode="new"
      this.content = {"forTable":"tableUser","enabel":false};
    },
    onExit(){
      this.showmode = 'LIST';
      this.mode="detail";
      this.searchTableData();
    },
    onRowClick(row) {
      this.content = row;
      this.showmode = "DETAIL";
      this.mode="detail";

    },
    searchTableData(){
      this.$api.getFieldExtends(
        this.searchdata,
        {
          onSucess: resp => {
            this.fieldextends = resp.data.data;
          }
        }
      );
    },
    resetTableData(){
      this.searchdata={
        currpage:1,
        pagelines:10,
        data:{
          type:"",
          belong: "system",
          fortable:"",
          domainid: "",
        }
      };
      this.searchTableData();
    },
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$api.deleteFieldExtend('',{
          data:this.multipleSelection
        },{
          onSucess:resp =>{
            if(resp.data.errcode==0){
              this.$message({
                showClose: true,
                message: this.$t('msg_del_success'),
                type: "success"
              });
              
              this.searchTableData()
            }else{
              this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
            }
          },
          onError:function(){

          }
        })
      }else{
        this.$message({
          showClose: true,
          message: "请先选择一条数据",
          type: "error"
        });
      }
    },
  }
};
</script>

<style>
</style>